import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../shared/inputs/Select';
import Modal from 'react-modal';
import Button from '../../shared/buttons/Button';
import TextInput from '../../shared/inputs/TextInput';
import CheckboxGroup from '../../shared/inputs/CheckboxGroup';
import ErrorMessage from '../../shared/message/ErrorMessage';
import AlertMessage from '../../shared/message/AlertMessage';
import { Helmet } from 'react-helmet';

class TeamGroupsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadGroups = this.loadGroups.bind(this);
    this.loadPermissions = this.loadPermissions.bind(this);
    this.loadGroupPermissions = this.loadGroupPermissions.bind(this);
    this.setGroupPermission = this.setGroupPermission.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.editGroup = this.editGroup.bind(this);
    this.deleteGroup = this.deleteGroup.bind(this);
    this.openAddGroupModal = this.openAddGroupModal.bind(this);
    this.openEditGroupModal = this.openEditGroupModal.bind(this);
    this.openRemoveGroupModal = this.openRemoveGroupModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onChangeNewGroupName = this.onChangeNewGroupName.bind(this);
    this.saveGroupPermissions = this.saveGroupPermissions.bind(this);
  }

  componentDidMount() {
    this.loadPermissions();
    if (this.props.groups && this.props.groups.length > 0) {
      this.loadGroupPermissions(this.props.groups[0]);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.group.length === 0 && this.props.group.length > 0) {
      this.loadGroupPermissions(this.props.groups[0]);
    }
  }
  /*
  componentWillReceiveProps(newProps) {
    const groups = newProps.groups;


    if (groups && groups.length > 0) {
      this.loadGroupPermissions(groups[0]);
    }
  }*/

  loadGroups() {
    this.props.loadGroups(this.props.team);
  }

  loadPermissions() {
    this.props.loadPermissions();
  }

  loadGroupPermissions(group) {
    this.props.loadGroupPermissions(this.props.team, group);
  }

  setGroupPermission(permissionId, checked) {
    const groupPermissions = this.props.groupPermissions;
    if (checked) {
      if (groupPermissions.indexOf(permissionId) === -1) groupPermissions.push(permissionId);
    } else if (groupPermissions.indexOf(permissionId) > -1) {
      groupPermissions.splice(groupPermissions.indexOf(permissionId), 1);
    }
    this.props.set({
      unsavedChanges: true,
      groupPermissions
    });
  }

  addGroup() {
    this.props.addGroup(this.props.team, this.props.newGroupName);
  }

  editGroup() {
    this.props.editGroup(this.props.team, this.props.groups, this.props.group[0].id, this.props.newGroupName);
  }

  deleteGroup() {
    this.props.deleteGroup(this.props.team, this.props.group[0].id);
  }

  openAddGroupModal() {
    this.props.set({ modal: 'add' });
  }

  openRemoveGroupModal() {
    this.props.set({ modal: 'remove' });
  }

  openEditGroupModal() {
    this.props.set({ modal: 'edit', newGroupName: this.props.groupName });
  }

  closeModal() {
    this.props.set({
      modal: false,
      newGroupName: ''
    });
  }

  onChangeNewGroupName(event) {
    this.props.set({ newGroupName: event.target.value });
  }

  saveGroupPermissions() {
    this.props.saveGroupPermissions(
      this.props.team,
      this.props.permissions,
      this.props.group[0].id,
      this.props.groupPermissions,
      this.props.groupPermissionsDb
    );
  }

  render() {
    const parentSelector = () => document.querySelector('.team-groups-page');
    const { groups, modal } = this.props;
    const hasPermission = this.props.checkPlanPermission('team_management') || false;
    const permissionRenderer = (permission) => (
      <span>
        {permission.description} ({permission.name})
      </span>
    );

    const modalContent = {
      add: (
        <div>
          <TextInput
            label="Group name"
            name="newGroupName"
            placeholder="E.g. 'editors'"
            value={this.props.newGroupName}
            onChange={this.onChangeNewGroupName}
            autoFocus={true}
          />
          <ErrorMessage error={this.props.newGroupNameError} />
          <Button buttonText="Save" extraClass="bulk-action-btn" onClick={this.addGroup} />{' '}
          <Button buttonText="Cancel" extraClass="bulk-action-btn grey" onClick={this.closeModal} />
        </div>
      ),
      edit: (
        <div>
          <TextInput
            label="Group name"
            name="newGroupName"
            placeholder="E.g. 'editors'"
            value={this.props.newGroupName}
            onChange={this.onChangeNewGroupName}
            autoFocus={true}
          />
          <ErrorMessage error={this.props.editGroupNameError} />
          <Button buttonText="Save" extraClass="bulk-action-btn" onClick={this.editGroup} />{' '}
          <Button buttonText="Cancel" extraClass="bulk-action-btn grey" onClick={this.closeModal} />
        </div>
      ),
      remove: (
        <div>
          <p>Are you sure you want to delete the group?</p>
          <Button buttonText="Yes" extraClass="bulk-action-btn" onClick={this.deleteGroup} />{' '}
          <Button buttonText="Cancel" extraClass="bulk-action-btn grey" onClick={this.closeModal} />
        </div>
      )
    }[modal];

    return (
      <div className="team-groups-page">
        <Helmet>
          <title> Access groups </title>
        </Helmet>
        <ErrorMessage error={this.props.error} />

        <Modal
          className="hc-modal-content"
          overlayClassName="hc-modal-overlay"
          appElement={document.querySelector('.page-container')}
          parentSelector={parentSelector}
          isOpen={Boolean(modal)}
          contentLabel="GroupModal"
          onRequestClose={this.closeModal}
        >
          {modalContent}
        </Modal>

        <div className="title-container">
          <h2>Access groups</h2>
        </div>

        <div className="main-content-container">
          <p>Administrate which functionality the groups should have access to</p>
        </div>

        <section>
          <div className="group-search-container">
            <b>Choose a group: &nbsp;</b>
            {groups && (
              <div className="group-details">
                <Select
                  options={groups}
                  value={this.props.group[0]}
                  className="group-selector"
                  onChange={this.loadGroupPermissions}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                  clearable={false}
                />
              </div>
            )}
            <Button
              buttonText="Add group"
              buttonClass="bulk-action-btn"
              onClick={this.openAddGroupModal}
              hasPermission={hasPermission}
            />
          </div>

          {this.props.unsavedChanges && (
            <div className="warning-div">
              <AlertMessage type="warning" tag="Warning" text="You have unsaved changes" />
            </div>
          )}

          <div className="permission-container">
            {this.props.group && this.props.group.length > 0 && (
              <div className="permission-details">
                Privileges for:
                <span className="permission-group-name">{this.props.group[0].name}</span>
                <Button
                  buttonText="Edit"
                  buttonClass="bulk-action-btn secondary-btn"
                  onClick={this.openEditGroupModal}
                  hasPermission={hasPermission}
                />
                <Button
                  buttonText="Delete"
                  buttonClass="bulk-action-btn secondary-btn negative"
                  onClick={this.openRemoveGroupModal}
                  hasPermission={hasPermission}
                />
              </div>
            )}

            {groups && groups.length > 0 && this.props.permissions ? (
              <CheckboxGroup
                options={this.props.permissions}
                valueKey="id"
                labelRenderer={permissionRenderer}
                onSelect={this.setGroupPermission}
                checked={this.props.groupPermissions}
                type={'thumbnail'}
              />
            ) : (
              <p>No groups found. Please add a group.</p>
            )}
          </div>
        </section>

        <section className="buttons-container">
          <Button
            buttonText="Save group"
            buttonClass="bulk-action-btn"
            onClick={this.saveGroupPermissions}
            hasPermission={hasPermission}
          />
        </section>
      </div>
    );
  }
}

TeamGroupsPage.propTypes = {
  team: PropTypes.object.isRequired,
  loadGroups: PropTypes.func.isRequired,
  groups: PropTypes.array
};

export default TeamGroupsPage;
